import ChatList from '../chat-list/ChatList';

const ChatBotAdminScreen = () => {    
    return (
        <ChatList />        
    )
}

ChatBotAdminScreen.guestGuard = false;
ChatBotAdminScreen.authGuard = true;

export { ChatBotAdminScreen }

export default ChatBotAdminScreen;